import moment from 'moment';
const GalaxyBookingMask = window.GalaxyBookingMask;

function initBookingMask() {
    var $bookingForm = $('.js-booking-form');

    $bookingForm.find('.js-bm-hotels').on('change', e => {
        const $target = $(e.target);
        const bookingURL = e.target.value || '';
        const bookingEngineID = $(e.target).find('option:selected').data('booking-engine') || '';

        $target.closest('.js-booking-form').attr('action', bookingURL).attr('data-booking-engine', bookingEngineID);
    });

    $bookingForm.on('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $target = $(e.target);

        var URL,
            urlBE = $target.attr('action');

        var arrayData = $target.serializeArray();

        var data = arrayData.reduce(function (data, el) {
            data[el.name] = el.value;
            return data;
        }, {});

        data.locale = $('html').attr('lang');

        var BeId = $target.data('booking-engine');

        URL = GalaxyBookingMask.buildUrl({
            BE: BeId,
            url: urlBE,
            data: data,
        });

        try {
            var _ga = window[window['GoogleAnalyticsObject']];
            var linkerParam;
            if (_ga) {
                linkerParam = _ga.getAll()[0].get('linkerParam');
            }
            if (linkerParam) {
                URL += '&' + linkerParam;
            }
        } catch (error) {
            console.error(error);
        }

        console.log('BM - Generated URL',URL);

        if (URL) {
            try {
                if (window.GalaxyEventTracking) {
                    /* EVENT TRACKING */
                    window.GalaxyEventTracking.events.bookingMaskSubmit({
                        buttonText: $target.find(':submit').text().trim() || $target.find(':submit').val().trim(),
                        position: GalaxyEventTracking.calculateElementPosition($target.find(':submit')),
                    });

                    window.GalaxyEventTracking.events.bookingIntention({
                        rooms: data.rooms,
                        adults: data.adults,
                        children: data.children,
                        code: data.promoCode,
                        dateIn: data.datein,
                        dateOut: data.dateout
                    });
                }
            } catch (error) {
                console.error(error);
            }

            return window.open(URL, '_blank')
        }
    });

}

export default initBookingMask;
